import styled from 'styled-components'
import { Container as InfoCard } from '../ui/InfoCardHome/styled'

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ $gap = '8px' }) => $gap};
`

export const InfoList = styled.ul`
	margin: 0;
	padding-left: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 6px;

	li {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	li::before {
		content: '';
		flex-shrink: 0;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background-color: currentColor;
	}
`

export const PhoneCard = styled(InfoCard)`
	align-items: center;
	width: 100%;
	${({ $isMobile }) =>
		$isMobile &&
		`
			border-radius: 0;
			width: calc(100% + 100px);
			margin: 0 -50px -50px;
			padding: 24px 18px calc(64px + env(safe-area-inset-bottom, 0px));
		`}
`

